var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { spacing } from 'syf-component-library/defaultTheme';
var Section = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 ", "px;\n  @media ", " {\n    margin: 0 ", "px;\n  }\n"], ["\n  margin: 0 ", "px;\n  @media ", " {\n    margin: 0 ", "px;\n  }\n"])), spacing.xlarge, query.lessThanMedium, spacing.base);
export default Section;
var templateObject_1;
//# sourceMappingURL=index.js.map